import React from 'react';
import { CheckCircle, Clock, Warning, Lightning, Microscope } from '@phosphor-icons/react';

export function StatusBadge({ status, size = 'default' }) {
  const cfg = {
    acceptable: { className: 'status-acceptable', icon: CheckCircle, label: 'Acceptable' },
    needs_review: { className: 'status-needs-review', icon: Clock, label: 'Needs Review' },
    not_acceptable: { className: 'status-not-acceptable', icon: Warning, label: 'Not Acceptable' }
  };
  const c = cfg[status] || cfg.needs_review;
  const Icon = c.icon;
  const sizeClass = size === 'large' ? 'px-4 py-2 text-sm' : 'px-2.5 py-1 text-xs';
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center gap-1.5 font-semibold rounded-sm ${c.className} ${sizeClass}`}>
      <Icon size={size === 'large' ? 18 : 14} weight="bold" />
      {c.label}
    </span>
  );
}

export function ModeBadge({ mode }) {
  if (mode === 'hazard') return (
    <span className="inline-flex items-center gap-1.5 px-3 py-1 text-xs font-bold uppercase tracking-wider text-[#2563EB] bg-[#E1EFFE] border border-[#A4CAFE] rounded-sm">
      <Lightning size={14} weight="bold" /> Risk Screen
    </span>
  );
  return (
    <span className="inline-flex items-center gap-1.5 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white bg-[#0B2447] rounded-sm">
      <Microscope size={14} weight="bold" /> Full Assessment
    </span>
  );
}

export function ModeBadgeSmall({ mode }) {
  if (mode === 'hazard') return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-[#2563EB] bg-[#E1EFFE] rounded-sm">
      <Lightning size={10} weight="bold" /> Risk Screen
    </span>
  );
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white bg-[#0B2447] rounded-sm">
      <Microscope size={10} weight="bold" /> Full Assessment
    </span>
  );
}

export function RegulatoryFlags({ flags }) {
  const activeFlags = [];
  if (flags.eu_annex_ii) activeFlags.push({ label: 'EU Annex II (Banned)', severity: 'high' });
  if (flags.eu_annex_iii_exceeded) activeFlags.push({ label: 'EU Annex III Exceeded', severity: 'high' });
  if (flags.eu_annex_iii && !flags.eu_annex_iii_exceeded) activeFlags.push({ label: 'EU Annex III', severity: 'medium' });
  if (flags.prop_65) activeFlags.push({ label: 'Prop 65', severity: 'medium' });
  if (flags.ifra_restricted) activeFlags.push({ label: 'IFRA Restricted', severity: 'medium' });
  if (flags.genotoxicity) activeFlags.push({ label: 'Genotoxic', severity: 'high' });
  if (flags.mutagenicity) activeFlags.push({ label: 'Mutagenic', severity: 'high' });
  const sens = flags.skin_sensitization;
  if (sens && sens !== 'None') activeFlags.push({ label: `Sensitizer (${sens})`, severity: 'low' });
  if (activeFlags.length === 0) return <span className="text-[#4B5563]">-</span>;
  return (
    <div className="flex flex-wrap gap-1">
      {activeFlags.map((f) => (
        <span key={f.label} className={`text-xs px-1.5 py-0.5 rounded-sm font-medium ${f.severity === 'high' ? 'bg-[#FDE8E8] text-[#9B1C1C]' : f.severity === 'medium' ? 'bg-[#FDF6B2] text-[#723B13]' : 'bg-[#E1EFFE] text-[#1E429F]'}`}>
          {f.label}
        </span>
      ))}
    </div>
  );
}
